

import React from 'react';
import './Invoice.css';

// Company details come from environment config so invoices never carry
// placeholder values. Set REACT_APP_COMPANY_* in .env before deploying.
const COMPANY_DETAILS = {
  name: process.env.REACT_APP_COMPANY_NAME || 'Bandhan Guru',
  gstNumber: process.env.REACT_APP_COMPANY_GST || '',
  address: process.env.REACT_APP_COMPANY_ADDRESS || '',
  website: process.env.REACT_APP_COMPANY_WEBSITE || 'www.bandhanguru.com',
  email: process.env.REACT_APP_COMPANY_EMAIL || 'info@bandhanguru.com',
  phone: process.env.REACT_APP_COMPANY_PHONE || '',
};

const InvoiceTemplate = React.forwardRef(({ data }, ref) => {
     if (!data) return null;
  return (
    <div ref={ref} className="invoice-wrapper">
        <div className="invoice-header">
            
          <div className='pdf-header-left'>
            <div className='logo-pdf'>
                <img src="/bandhanguru_logo.svg" alt="logo" />
            </div>
            <div>
            <h2 className='heading-2'>{COMPANY_DETAILS.name}</h2>
            <p>{COMPANY_DETAILS.website}</p>
            <p>{COMPANY_DETAILS.email}</p>
            {COMPANY_DETAILS.phone && <p>{COMPANY_DETAILS.phone}</p>}
            </div>
          </div>
        <div className='pdf-header-right'>
  {COMPANY_DETAILS.address && <p>{COMPANY_DETAILS.address}</p>}
  {COMPANY_DETAILS.gstNumber && <p>GST No: {COMPANY_DETAILS.gstNumber}</p>}
  <p>
    Date: {new Date(data?.invoiceDate).toLocaleDateString()}
  </p>
</div>
        </div>
      <div className="invoice-card">

        {/* HEADER */}
        

        {/* BILL TO */}
        <div className="invoice-info">
          <div>
  <p>Billed To</p>

  <strong>{data?.user?.name}</strong>

  <p>{data?.user?.mobile_number}</p>

  <p>{data?.user?.email}</p>

  <p>
    Address:
    <strong>
      {' '}
      {data?.user?.address || 'N/A'}
    </strong>
  </p>

  <p>
    GST No:
    <strong>
      {' '}
      {data?.user?.gstNumber || 'N/A'}
    </strong>
  </p>
</div>

          <div className='flex-pdf-data'>
            <p>Invoice No: <strong>{data?.invoiceNumber}</strong></p>
            {COMPANY_DETAILS.gstNumber && <p>GST No: <strong>{COMPANY_DETAILS.gstNumber}</strong></p>}
            <p>Address: <strong>{data?.user?.address || 'N/A'}</strong></p>
            <p className='invoice-amount'>Invoice Amt: <strong>{data?.amount}</strong></p>
          </div>
        </div>
        <div className="payment-details">
  <h4>Payment Details</h4>

  <p>
    <strong>Payment Method:</strong>{' '}
    {data?.paymentGateway || 'N/A'}
  </p>

  <p>
    <strong>Transaction Status:</strong>{' '}
    {data?.status}
  </p>

  <p>
    <strong>Currency:</strong>{' '}
    {data?.currency}
  </p>

  <p>
    <strong>Invoice Number:</strong>{' '}
    {data?.invoiceNumber}
  </p>
</div>

        {/* TABLE */}
        <table className="invoice-table">
          <thead>
            <tr>
              <th>ITEM DETAIL </th>
              <th>QTY</th>
              <th>RATE</th>
              <th>AMOUNT</th>
            </tr>
          </thead>
          <tbody>
            <tr>
  <td>
    {data.plan?.name} Subscription Plan
  </td>

  <td>1</td>

  <td>₹{data.baseAmount}</td>

  <td>₹{data.baseAmount}</td>
</tr>
          </tbody>
        </table>

        {/* TOTAL */}
        <div className="invoice-summary">

  <p>
    Base Amount:
    <strong> ₹{data?.baseAmount}</strong>
  </p>

  {data?.cgst > 0 && (
    <p>
      CGST (9%):
      <strong> ₹{data?.cgst}</strong>
    </p>
  )}

  {data?.sgst > 0 && (
    <p>
      SGST (9%):
      <strong> ₹{data?.sgst}</strong>
    </p>
  )}

  {data?.igst > 0 && (
    <p>
      IGST (18%):
      <strong> ₹{data?.igst}</strong>
    </p>
  )}

  <hr />

  <h3>
    Grand Total: ₹{data?.amount}
  </h3>

</div>

        <div className="invoice-footer">
          <p>Thanks for the business.</p>
          <p>Signature</p>
        </div>

      </div>
    </div>
  );
});

export default InvoiceTemplate;
